export default import.meta.ROLLUP_FILE_URL_CzMNP2Dg;